import { Injectable, TemplateRef } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { MsgOptions } from './MsgOptions';
import { MsgOptionsCookie } from './MsgOptionsCookie';


@Injectable()
export class ConfirmState {
    options: MsgOptions;
    modal: NgbModalRef;
    template: TemplateRef<any>;
    labelno: string;
    labelyes: string;
    cookieOptions: MsgOptionsCookie;
}
